module.exports = __webpack_public_path__ + "static/img/monitiornew2.9eef2544.webp";